<!-- 最新动态 -->
<template>
  <div class="flex flex-col gap-4 mt-7">
    <!-- 标题 -->
    <div class="flex w-full justify-between pr-4 text-primary">
      <div class="flex flex-col px-6 items-left recentNewsTitle">
        <div class="text-lg font-bold">最新动态</div>
        <div class="flex items-center gap-1">
          <div class="w-5 h-0.5 bg-primary" />
          <span class="text-xs font-semibold">News</span>
        </div>
      </div>

      <div
        class="flex items-center gap-1"
        @click="goMore"
      >
        <img :src="require('@/assets/moreIcons.png')" alt="" />
        <span class="text-xs"> 查看更多</span>
      </div>
    </div>
    <!-- 内容 -->
    <div
      class="px-4 relative"
      @click="() => handleNavigateToDetail(exhibitionNews?.id)"
    >
      <div class="w-full h-52">
        <img class="w-full h-full" :src="exhibitionNews.picUrl?'/mainsys/UserFiles/menupic/' + exhibitionNews.picUrl:defaultImg" />
      </div>
      <div
        class="w-full text-white absolute bottom-2 left-0 px-6 z-10 flex flex-col gap-1"
      >
        <span class="text-xs">{{
          exhibitionNews?.addDate | day("YYYY年MM月DD日")
        }}</span>
        <span class="text-xs">{{ exhibitionNews?.descripton }}</span>
      </div>
    </div>
    <div class="flex flex-col gap-2 px-4">
      <div
        class="flex flex-col gap-1 pb-3"
        :style="{
          borderBottom: '1px',
          borderColor: '#e8e8e8',
          borderStyle: idx + 1 === recentNewsList?.length ? 'solid' : 'dashed',
        }"
        v-for="(item, idx) in recentNewsList"
        :key="item?.id"
        @click="() => handleNavigateToDetail(item?.id)"
      >
        <div class="cursor-pointer text-primary font-normal">
          【{{ item?.addDate | day("YYYY年MM月DD") }}】
        </div>
        <div  style="color:#333333;opacity: 0.6;">{{ item?.title | truncate(40) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import { array_ } from "../utils/index";
import mixins from "../hooks";
import imgURL from "../filters/imgURL";
import defaultImg from "@/assets/xinwen.png";

export default {
  name: "recentNews",
  mixins: [mixins],
  props: {
    info: {
      default: () => {
        return {};
      },
    },
  },
  data(){
    return{
      defaultImg:defaultImg,
    }
  },
  computed: {
    // 信息列表
    recentNewsList() {
      let item = this.info;
      let data = [];
      if (item.twoData && item.twoData.length > 0) {
        item.twoData.forEach((val) => {
          if (val.data && val.data.length > 0) {
            val.data = val.data.length > 4 ? val.data.splice(0, 4) : val.data;
          }
          if (val.data && val.data.length > 0) {
            data.push(...val.data);
          }
        });
      }
      data.sort(this.dateData("addDate", false));
      console.log(data,'data最新？')
      return data.length > 3 ? data.splice(0, 3) : data;
    },
    // 展示新闻
    exhibitionNews() {
      return this.recentNewsList?.[0];
    },
  },
  methods:{
    dateData(property, bol) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (bol) {
          // 升序
          return Date.parse(value1) - Date.parse(value2);
        } else {
          // 降序
          return Date.parse(value2) - Date.parse(value1);
        }
      };
    },
    goMore(){
      console.log(this.info,'info')
      if(this.info.twoData&&this.info.twoData.length>0){
        this.$router.push({
          path: "List:menuId",
          name: "List",
          params: { menuId: this.info.twoData[0].id },
        });
      }
    }
  }
};
</script>
<style scoped>
.recentNewsTitle {
  background: url("~@/assets/title.png") no-repeat;
  background-size: 100% 100%;
}
</style>
